import { ApiService, LabOrder } from "pwapi";

import {
  ADMIN_ORDER_PRINT_SLIDE_FAILURE,
  ADMIN_ORDER_PRINT_SLIDE_REQUEST,
  ADMIN_ORDER_PRINT_SLIDE_SUCCESS,
  ADMIN_ORDERS_PRINT_FAILURE,
  ADMIN_ORDERS_PRINT_REQUEST,
  ADMIN_ORDERS_PRINT_RETRIEVE_FAILURE,
  ADMIN_ORDERS_PRINT_RETRIEVE_REQUEST,
  ADMIN_ORDERS_PRINT_RETRIEVE_SUCCESS,
  ADMIN_ORDERS_PRINT_SLIDES_FAILURE,
  ADMIN_ORDERS_PRINT_SLIDES_REQUEST,
  ADMIN_ORDERS_PRINT_SLIDES_SUCCESS,
  ADMIN_ORDERS_PRINT_SUCCESS,
  ADMIN_UPDATE_ORDERS_PRINT_FAILURE,
  ADMIN_UPDATE_ORDERS_PRINT_REQUEST,
  ADMIN_UPDATE_ORDERS_PRINT_SUCCESS,
} from "./adminConstants";
import {
  COMPLETE_STAIN_ORDER_FAILURE,
  COMPLETE_STAIN_ORDER_REQUEST,
  COMPLETE_STAIN_ORDER_SUCCESS,
  DELETE_STAIN_ORDER_FAILURE,
  DELETE_STAIN_ORDER_REQUEST,
  DELETE_STAIN_ORDER_SUCCESS,
  LABORDERS_LIST_REQUEST,
  PARTIAL_UPDATE_STAIN_ORDER_REQUEST,
  PARTIAL_UPDATE_STAIN_ORDER_SUCCESS,
  PARTIAL_UPDATE_STAIN_ORDER_FAILURE,
} from "./constants";
import { createAsyncSaga, AsyncSagaAction } from "../utils/asyncActions";

export const fetchLabOrders = (payload: any) => {
  return {
    type: LABORDERS_LIST_REQUEST,
    payload,
  };
};

export const adminLabOrderPrintRequest = createAsyncSaga(
  ADMIN_ORDERS_PRINT_REQUEST,
  ADMIN_ORDERS_PRINT_SUCCESS,
  ADMIN_ORDERS_PRINT_FAILURE,
  () => "admin/orders/print",
  ApiService.printAdminLabOrder
) as AsyncSagaAction<{ requestBody: any }>;

export const adminLabOrderPrintRetrieveRequest = createAsyncSaga(
  ADMIN_ORDERS_PRINT_RETRIEVE_REQUEST,
  ADMIN_ORDERS_PRINT_RETRIEVE_SUCCESS,
  ADMIN_ORDERS_PRINT_RETRIEVE_FAILURE,
  ({ id }) => `admin/orders/print/${id}`,
  ApiService.retrieveLabOrderPrintLog
) as AsyncSagaAction<{ id: number }>;

export const updateLabOrderPrint = createAsyncSaga(
  ADMIN_UPDATE_ORDERS_PRINT_REQUEST,
  ADMIN_UPDATE_ORDERS_PRINT_SUCCESS,
  ADMIN_UPDATE_ORDERS_PRINT_FAILURE,
  ({ id }) => `admin/orders/print/${id}`,
  ApiService.updateLabOrderPrintLog
) as AsyncSagaAction<{ id: number; requestBody?: any }>;

export const printSlidesLabOrderPrintLog = createAsyncSaga(
  ADMIN_ORDERS_PRINT_SLIDES_REQUEST,
  ADMIN_ORDERS_PRINT_SLIDES_SUCCESS,
  ADMIN_ORDERS_PRINT_SLIDES_FAILURE,
  ({ id }) => `/api/lab-order-print-log/${id}/print_slides/`,
  ApiService.printSlidesLabOrderPrintLog
) as AsyncSagaAction<
  Parameters<typeof ApiService.printSlidesLabOrderPrintLog>[0]
>;

type CancelArgs = { id: number };
export const cancelLabOrder = createAsyncSaga(
  DELETE_STAIN_ORDER_REQUEST,
  DELETE_STAIN_ORDER_SUCCESS,
  DELETE_STAIN_ORDER_FAILURE,
  ({ id }: CancelArgs) => {
    return `/stain-order/${id}/delete`;
  },
  ({ id }: CancelArgs) => ApiService.destroyLabOrder({ id })
) as AsyncSagaAction<CancelArgs>;

export const completeLabOrder = createAsyncSaga(
  COMPLETE_STAIN_ORDER_REQUEST,
  COMPLETE_STAIN_ORDER_SUCCESS,
  COMPLETE_STAIN_ORDER_FAILURE,
  (id: number) => {
    return `/stain-order/${id}/complete`;
  },
  (id: number) => ApiService.completeLabOrder({ id })
) as AsyncSagaAction<number>;

type PartialUpdateLabOrderArgs = { id: number; requestBody: Partial<LabOrder> };
export const partialUpdateLabOrder = createAsyncSaga(
  PARTIAL_UPDATE_STAIN_ORDER_REQUEST,
  PARTIAL_UPDATE_STAIN_ORDER_SUCCESS,
  PARTIAL_UPDATE_STAIN_ORDER_FAILURE,
  ({ id }: PartialUpdateLabOrderArgs) => {
    return `/stain-order/${id}/partial-update`;
  },
  ({ id, requestBody }: PartialUpdateLabOrderArgs) =>
    ApiService.partialUpdateLabOrder({
      id,
      requestBody: requestBody as LabOrder,
    })
) as AsyncSagaAction<PartialUpdateLabOrderArgs>;

export const printSlideAdminLabOrder = createAsyncSaga(
  ADMIN_ORDER_PRINT_SLIDE_REQUEST,
  ADMIN_ORDER_PRINT_SLIDE_SUCCESS,
  ADMIN_ORDER_PRINT_SLIDE_FAILURE,
  ({ id }) => `/api/admin/lab-orders/${id}/print_slide/`,
  ApiService.printSlideAdminLabOrder
) as AsyncSagaAction<Parameters<typeof ApiService.printSlideAdminLabOrder>[0]>;
